import { accountService } from '../../services/AccountService';

export default {
    name: 'AccountActivation',
    data: () => {
        return {
            loading: true,
            errors: '',
            accountActivation: {}
        }
    },
    created() {
        this.accountActivation.Id = this.$route.params.id;
        this.accountActivation.Token = this.$route.query.token;

        this.activateAccount();
    },
    methods: {
        activateAccount() {
            var model = this;
            accountService.activateAccount(model.accountActivation)
                .then(response => {
                    debugger
                    if (response.status === 200) {
                        this.$router.push({ name: 'PasswordReset', params: { id: response.data.Id, userName: response.data.UserName }, query: { token: response.data.Token } });
                    }
                    else
                        model.errors = 'A aparut o eroare la activarea acestui utilizator. Va rugam sa contactati administratorul acestei aplicatii.';
                })
                .catch(e => {
                    showErrorNotification(e);
                })
                .finally(() => this.loading = false);

        }
    }
}
